const LOGO_URL = "https://storage.readdy-site.link/project_files/91f0fbb4-559d-4c0a-96a3-54de25a4114a/f867e845-4777-44fb-9aa5-a8d55fc6b91c_216527.png?v=dde2cd95ac7ea8472f8ff80887329948";

type LogoVariant = "dark" | "light";

interface LogoProps {
  variant?: LogoVariant;
  size?: "sm" | "md" | "lg";
  showText?: boolean;
}

export default function Logo({ variant = "dark", size = "md", showText = true }: LogoProps) {
  const sizeMap = {
    sm: { img: "h-7 w-7", text1: "text-sm", text2: "text-sm", gap: "gap-2" },
    md: { img: "h-9 w-9", text1: "text-base", text2: "text-base", gap: "gap-2.5" },
    lg: { img: "h-12 w-12", text1: "text-xl", text2: "text-xl", gap: "gap-3" },
  };

  const s = sizeMap[size];
  const textColor = variant === "light" ? "text-white" : "text-gray-900";
  const subColor = variant === "light" ? "text-white/70" : "text-gray-500";

  return (
    <div className={`flex items-center ${s.gap} select-none`}>
      <img
        src={LOGO_URL}
        alt="mail.net.az logo"
        className={`${s.img} object-contain flex-shrink-0`}
      />
      {showText && (
        <div className="flex items-baseline leading-none">
          <span
            className={`font-extrabold tracking-tight ${s.text1} ${textColor}`}
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", letterSpacing: "-0.02em" }}
          >
            mail
          </span>
          <span
            className={`font-medium ${s.text2} ${subColor}`}
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", letterSpacing: "-0.01em" }}
          >
            .net.az
          </span>
        </div>
      )}
    </div>
  );
}
